export default __webpack_public_path__ + "static/media/icw-persona.e67c4fbc.jpg";